import { Row, Col, Form } from 'react-bootstrap';

interface FilterSectionProps {
  filterName: string;
  filterBrand: string;
  filterCategory: string;
  setFilterName: (value: string) => void;
  setFilterBrand: (value: string) => void;
  setFilterCategory: (value: string) => void;
  loading: boolean;
}

export const FilterSection = ({
  filterName,
  filterBrand,
  filterCategory,
  setFilterName,
  setFilterBrand,
  setFilterCategory,
  loading,
}: FilterSectionProps) => (
  <div className="bg-white rounded-3 p-3 mb-3" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
    <Row className="g-3">
      <Col md={4}>
        <Form.Control
          type="text"
          placeholder="Search by name..."
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
          disabled={loading}
          style={{ borderRadius: '6px', border: '1px solid #e0e0e0' }}
        />
      </Col>
      <Col md={4}>
        <Form.Control
          type="text"
          placeholder="Search by brand..."
          value={filterBrand}
          onChange={(e) => setFilterBrand(e.target.value)}
          disabled={loading}
          style={{ borderRadius: '6px', border: '1px solid #e0e0e0' }}
        />
      </Col>
      <Col md={4}>
        <Form.Control
          type="text"
          placeholder="Search by category..."
          value={filterCategory}
          onChange={(e) => setFilterCategory(e.target.value)}
          disabled={loading}
          style={{ borderRadius: '6px', border: '1px solid #e0e0e0' }}
        />
      </Col>
    </Row>
  </div>
);
